module.exports = __webpack_public_path__ + "img/loginBGtriniti.7999550f.png";